<template>
    <card-skeleton>
        <card-title :text="t('profile.confirmPhoneTitle')"></card-title>
        <v-card-text>
            <v-row v-show="!showConfirmForm">
                <v-col class="v-col-xl-6">
                    <v-btn color="primary" size="x-large" block @click="initConfirm">{{ t('profile.confirmPhoneYes') }}</v-btn>
                </v-col>
                <v-col class="v-col-xl-6">
                    <v-btn size="x-large" block @click="goBack"> {{ t('profile.cancel') }}</v-btn>
                </v-col>
            </v-row>

            <v-container v-show="showConfirmForm">
                <v-row>
                    <v-col>
                        <v-text-field
                            v-model="confirmCode"
                            :placeholder="t('profile.confirmPhoneCode')"
                            :label="t('profile.confirmPhoneCode')"
                            @keydown.enter="confirmPhone"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="v-col-xl-6">
                        <v-btn color="primary" :loading="userStore.isVerifying" size="x-large" block @click="confirmPhone">{{
                            t('profile.confirmPhoneConfirm')
                        }}</v-btn>
                    </v-col>
                    <v-col class="v-col-xl-6">
                        <v-btn size="x-large" block @click="goBack"> {{ t('profile.cancel') }}</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <notification-bar
            v-model:show="notificationBarState.show"
            :color="notificationBarState.color"
            :icon="notificationBarState.icon"
            :border="notificationBarState.border"
            :message="notificationBarState.message"
        />
    </card-skeleton>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useReCaptcha } from 'vue-recaptcha-v3-esm';
import { useUserStore } from '@geta/kolumbus-frontend/features/authentication';
import { i18nRoute } from '@/i18n';
import { routeNames } from '@/router';
import CardSkeleton from '@/features/common/components/CardSkeleton.vue';
import CardTitle from '@/features/common/components/CardTitle.vue';
import { RECAPTCHA_ACTIONS } from '@/features/common/components/form/constants';
import { NotificationBar } from '@/features/common/components/form';
import { useFormData, useNotification } from '@/features/common/components/form/composables';
import { navigateBack } from '@/features/Profile/helpers';

const { t } = useI18n();
const router = useRouter();
const userStore = useUserStore();
const recaptcha = useReCaptcha();

const showConfirmForm = ref(false);
const confirmCode = ref('');

const { notificationBarState, notificationSuccess, notificationError } = useNotification();
const { executeRecaptcha } = useFormData();

async function initConfirm() {
    const recaptchaToken = recaptcha ? await executeRecaptcha(RECAPTCHA_ACTIONS.CONFIRM_PHONE) : '';
    await userStore.requestForPhoneVerification(userStore.user.phone, recaptchaToken);
    showConfirmForm.value = true;
}

async function confirmPhone() {
    const recaptchaToken = recaptcha ? await executeRecaptcha(RECAPTCHA_ACTIONS.VERIFY_CONFIRM_PHONE) : '';
    const verificationResult = await userStore.checkPhoneVerificationCode(confirmCode.value, userStore.user.phone, recaptchaToken);

    if (verificationResult) {
        notificationBarState.value = notificationSuccess(t('profile.confirmPhoneSuccess'));
        await router.push(i18nRoute({ name: routeNames.home }));
    } else {
        notificationBarState.value = notificationError(t('profile.confirmPhoneError'));
    }
}

const goBack = () => navigateBack(2, -1, routeNames.profile);
</script>
